<template>
  <div>
    <div>
      <!-- <div class="row">
        <div class="offset-sm-9 col-sm-3">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              v-model="globalSearch"
              @input="setData()"
            />
            <label for="sizeOptions" class="input-group-text"
              ><font-awesome-icon
                class="my-auto"
                :icon="['fas', 'magnifying-glass']"
            /></label>
          </div>
        </div>
      </div> -->
    </div>
    <div
      :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 shadow-table p-1`"
    >
      <table :class="`table table-${getColorMode.background} w-100`">
        <thead>
          <tr>
            <th>
              Nombre
              <span
                class="cursor-pointer"
                @click="
                  orderTable.row === 'name'
                    ? orderTable.type === 'asc'
                      ? (orderTable.type = 'desc')
                      : (orderTable.type = 'asc')
                    : ((orderTable.row = 'name'), (orderTable.type = 'asc'))
                "
              >
                <font-awesome-icon
                  class="my-auto"
                  :icon="
                    orderTable.row === 'name'
                      ? orderTable.type === 'asc'
                        ? ['fas', 'sort-up']
                        : ['fas', 'sort-down']
                      : ['far', 'sort']
                  "
              /></span>
            </th>
            <th>Versión</th>
            <th>Propietario</th>
            <th>
              Creación
              <span
                class="cursor-pointer"
                @click="
                  orderTable.row === 'created_at'
                    ? orderTable.type === 'desc'
                      ? (orderTable.type = 'asc')
                      : (orderTable.type = 'desc')
                    : ((orderTable.row = 'created_at'),
                      (orderTable.type = 'desc'))
                "
              >
                <font-awesome-icon
                  class="my-auto"
                  :icon="
                    orderTable.row === 'created_at'
                      ? orderTable.type === 'asc'
                        ? ['fas', 'sort-down']
                        : ['fas', 'sort-up']
                      : ['far', 'sort']
                  "
              /></span>
            </th>
            <!-- <th>Última modificación</th> -->
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr
            v-for="(item, key) in tableItems"
            class="table-item"
            :key="`folder-children-${key}`"
            @click.exact="selectItem(item)"
            @dblclick="
              item.extension
                ? showFile(item)
                : showFolder(this.projectId, item.id)
            "
            @click.ctrl.exact="selectMultipleFolder(item)"
            :ref="`item-${item.id}`"
            :class="{
              'table-active': (item.id === selectedItemId || selectedFolders.includes(item.id)),
              'cursor-pointer': item.folder_structure_id,
            }"
          >
            <td>
              <font-awesome-icon
                :class="item.icon ? 'text-warning' : setIconColor(item)"
                :icon="item.icon ? ['fas', item.icon] : ['fal', setIcon(item)]"
                size="lg"
              />
              {{
                filePrevisualization
                  ? item.name.slice(0, 10) + "..."
                  : item.name
              }}
              <span style="font-size: 70%">
                {{
                  item.files_count > 0
                    ? `(${item.files_count} archivo${
                        item.files_count > 1 ? "s" : ""
                      })`
                    : ""
                }}
              </span>
            </td>
            <td>{{ item.version }}</td>
            <td>{{ item.owner ? item.owner.name : "-" }}</td>
            <td>{{ formatUploadDate(item.created_at) }}</td>
            <!-- <td>{{ formatUploadDate(item.created_at) }}</td> -->
          </tr>
        </tbody>
        <tbody v-if="loading || tableItems.length === 0">
          <tr>
            <td
              :class="[{ 'text-center': true }, loading ? 'pt-4' : 'py-5']"
              :colspan="4"
            >
              <span v-if="loading">
                <content-loader
                  viewBox="0 0 400 90"
                  :speed="0.8"
                  primaryColor="#f3f3f3"
                  secondaryColor="#ecebeb"
                >
                  <rect x="0" y="0" rx="1" ry="5" width="400" height="8" />
                  <rect x="0" y="15" rx="1" ry="5" width="400" height="8" />
                  <rect x="0" y="30" rx="1" ry="5" width="400" height="8" />
                  <rect x="0" y="45" rx="1" ry="5" width="400" height="8" />
                  <rect x="0" y="60" rx="1" ry="5" width="400" height="8" />
                  <rect x="0" y="75" rx="1" ry="5" width="400" height="8" />
                  <rect x="0" y="90" rx="1" ry="5" width="400" height="8" />
                </content-loader>
              </span>
              <span v-if="!loading && tableItems.length === 0" class="pb-5"
                >No hay elementos.</span
              >
            </td>
          </tr>
        </tbody>
        <!-- <tbody v-else>
          <tr>
            <td class="text-center py-5" :colspan="columns.length + 1">
              <span v-if="loading">Buscando...</span>
              <span v-else>No existen datos disponibles</span>
            </td>
          </tr>
        </tbody> -->
      </table>
    </div>
    <!-- <div class="row mt-4">
      <div class="col-sm-6 d-flex justify-content-start my-auto">
        <div>
          <span class="items-per-page-text mb-0">Items por página:</span>
          <select
            id="sizeOptions"
            v-model="size"
            class="border-secondary mx-2"
            aria-label="Default select example"
            @change="changeSize()"
          >
            <option
              v-for="(value, key) in sizeOptions"
              v-bind:key="`size-select-${key}`"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <p class="table-entries-text mb-0 text-left">
          {{ calcSize }} registros de {{ total }}
        </p>
      </div>
      <div class="col-sm-6">
        <nav aria-label="Paginación">
          <ul class="pagination justify-content-end">
            <span class="mx-4 my-auto items-per-page-text"
              >Página {{ page }} de {{ lastPage }}</span
            >
            <template v-if="page > 1">
              <li class="page-item">
                <a class="page-link" href="javascript:;" @click="page = 1"
                  ><font-awesome-icon :icon="['fal', 'chevrons-left']"
                /></a>
              </li>
              <li class="page-item" aria-current="page">
                <a
                  href="javascript:;"
                  class="page-link"
                  @click="page = page - 1"
                  ><font-awesome-icon :icon="['fal', 'chevron-left']"
                /></a>
              </li>
            </template>
            <template v-else>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevrons-left']"
                /></a>
              </li>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevron-left']"
                /></a>
              </li>
            </template>
            <li class="page-item active" aria-current="page">
              <span class="page-link">{{ page }}</span>
            </li>
            <template v-if="page < lastPage">
              <li class="page-item" aria-current="page">
                <a
                  href="javascript:;"
                  class="page-link"
                  @click="page = page + 1"
                  ><font-awesome-icon :icon="['fal', 'chevron-right']"
                /></a>
              </li>
              <li class="page-item">
                <a
                  class="page-link"
                  href="javascript:;"
                  @click="page = lastPage"
                  ><font-awesome-icon :icon="['fal', 'chevrons-right']"
                /></a>
              </li>
            </template>
            <template v-else>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevron-right']"
                /></a>
              </li>
              <li class="page-item disabled">
                <a
                  class="page-link"
                  href="javascript:;"
                  tabindex="-1"
                  aria-disabled="true"
                  ><font-awesome-icon :icon="['fal', 'chevrons-right']"
                /></a>
              </li>
            </template>
          </ul>
        </nav>
      </div>
    </div> -->
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "tree",
  emits: [
    "setData",
    "setFile",
    "setFolder",
    "newFile",
    "setItem",
    "handleDeleteFileButton",
    "folderViewSelectedItem",
  ],
  components: { ContentLoader},
  props: {
    items: { type: Array },
    folderStructureName: { default: "" },
    folderList: { type: Array },
    viewFiles: { default: false },
    filePrevisualization: { type: Boolean, default: false },
    projectId: { default: null },
    page: { default: 1 },
    size: { default: 10 },
  },
  data() {
    return {
      selectedItem: null,
      itemsData: null,
      loading: false,
      componentKey: 0,
      tableItems: [],
      result: [],
      delay: 200,
      clicks: 0,
      timer: null,
      selectedItemId: null,
      selectedFolders: [],
      orderTable: {
        row: "name",
        type: "asc",
      },
    };
  },
  mounted() {
    this.itemsData = this.items;
    this.setTableItems();
  },
  methods: {
    ...mapMutations("general", ["setOpenedFolders"]),
    async setTableItems() {
      this.loading = true;
      console.log(this.loading);
      if (this.itemsData && this.itemsData.length > 0) {
        this.tableItems = [];
        if (this.itemsData[0] && this.itemsData[0].files) {
          const files = await this.itemsData[0].files.map((item) => {
            return item;
          });
          this.tableItems.push(...files);
        }
        const folders = await this.itemsData[0].folder_children.map((item) => {
          return item;
        });
        this.tableItems.push(...folders);
        this.sortTableItems(this.tableItems);
        this.loading = false;
      }
    },
    sortTableItems(items) {
      if (this.orderTable.type === "asc") {
        items.sort((a, b) => {
          if (a[this.orderTable.row] < b[this.orderTable.row]) {
            return -1;
          }
          if (a[this.orderTable.row] > b[this.orderTable.row]) {
            return 1;
          }

          return 0;
        });
      } else {
        items.sort((a, b) => {
          if (a[this.orderTable.row] > b[this.orderTable.row]) {
            return -1;
          }
          if (a[this.orderTable.row] < b[this.orderTable.row]) {
            return 1;
          }

          return 0;
        });
      }
    },
    formatUploadDate(uploadDate) {
      const dateObject = new Date(uploadDate);
      return `${dateObject.getUTCDate()}-${
        dateObject.getUTCMonth() + 1
      }-${dateObject.getUTCFullYear()} ${String(
        dateObject.getUTCHours()
      ).padStart(2, "0")}:${String(dateObject.getUTCMinutes()).padStart(
        2,
        "0"
      )}`;
    },
    selectMultipleFolder(item){
      if (item.extension) {
        this.$emit("multipleFolderDownload", []);
      } else {
        let currentFolders = this.selectedFolders
        currentFolders.includes(item.id) ? currentFolders.splice(currentFolders.indexOf(item.id), 1) : currentFolders.push(item.id)
        this.selectedFolders = currentFolders
        this.$emit("multipleFolderDownload", currentFolders);
      }
    },
    selectItem(item) {
      this.selectedItemId = item.id;
      let currentFolder = [item.id]
      this.selectedFolders = currentFolder
      this.selectedFolder
      if (item.extension) {
        this.$emit("folderViewSelectedItem", item);
        this.$emit("multipleFolderDownload", []);
      } else {
        this.$emit("folderViewSelectedItem", null);
        this.$emit("multipleFolderDownload", currentFolder);
      }
    },
    setIcon(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "file-image";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "file-word";
      } else if (["xml"].includes(item.extension)) {
        return "file-spreadsheet";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "file-pdf";
      } else {
        return "file";
      }
    },
    setIconColor(item) {
      if (["jgp", "svg", "png"].includes(item.extension)) {
        return "text-secondary";
      } else if (["doc", "docx"].includes(item.extension)) {
        return "text-word";
      } else if (["xml", "csv"].includes(item.extension)) {
        return "text-success";
      } else if (["dwg", "pdf"].includes(item.extension)) {
        return "text-danger";
      } else {
        return "text-secondary";
      }
    },
    newItem(item) {
      this.selectedItem = item;
      item.isEdit = false;
      item.newIcon = "folder";
      item.newName = null;
      item.newFolderId = item.folder_structure_id ? item.id : null;
      item.folder_structure_id = item.folder_structure_id
        ? item.folder_structure_id
        : item.id;
      item.newDescription = null;
      item.showForm = true;
      item.id = null;
    },
    editItem(item) {
      this.selectedItem = item;
      item.isEdit = true;
      item.newIcon = item.icon;
      item.newName = item.name;
      item.newFolderId = item.folder_id;
      item.newDescription = item.description;
      item.showForm = true;
    },
    deleteItem(item) {
      let app = this;
      this.loading = true;
      this.axios
        .delete(
          `folder_structures/${item.folder_structure_id}/folders/${item.id}`
        )
        .then(() => {
          app.$emit("setData");
          app.loading = false;
        })
        .catch((error) => {
          console.log(error);
          app.loading = false;
        });
    },
    saveItem(item) {
      let saveData = {
        folder: {
          name: item.newName,
          description: item.newDescription,
          icon: item.newIcon,
          folder_id: item.newFolderId,
        },
      };
      let app = this;
      this.loading = true;
      if (item.id) {
        this.axios
          .put(
            `folder_structures/${item.folder_structure_id}/folders/${item.id}`,
            saveData
          )
          .then(() => {
            item.showForm = false;
            app.$emit("setData");
            app.loading = false;
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      } else {
        this.axios
          .post(
            `folder_structures/${item.folder_structure_id}/folders`,
            saveData
          )
          .then(() => {
            item.showForm = false;
            app.$emit("setData");
            app.loading = false;
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      }
    },
    showItem(item) {
      this.$emit("setItem", item);
    },
    showFile(item) {
      this.$emit("setFile", item);
    },
    async showFolder(projectId, folder) {
      this.loading = true;
      try {
        const folders = await this.axios.get(
          `projects/${projectId}/folders/${folder}?page=${this.page}&size=${this.size}`
        );
        this.itemsData = folders.data.body;
        this.componentKey += 1;
        this.setTableItems();
        this.setFolder(folder);
        this.setBreadcrumb(folders.data.body[0].breadcrumb);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    showParentFolder(folder) {
      if (folder.folder_structure_id) {
        this.axios
          .get(`projects/${this.projectId}/folders/${folder.id}/show_parent`)
          .then((result) => {
            this.itemsData = result.data.body;
            this.componentKey += 1;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    setData() {
      this.$emit("setData");
    },
    setItem(item) {
      this.$emit("setItem", item);
    },
    setFile(item) {
      this.$emit("setFile", item);
    },
    setFolder(item) {
      this.$emit("setFolder", item);
    },
    setBreadcrumb(item) {
      this.$emit("setBreadcrumb", item);
    },
    newFile(item) {
      let file = { name: null, folder_id: item.id };
      this.$emit("setFile", file);
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
  watch: {
    selectedItem: {
      handler: function (newVal) {
        newVal.extension
          ? this.$emit("handleDeleteFileButton", true)
          : this.$emit("handleDeleteFileButton", false);
      },
    },
    orderTable: {
      handler: function () {
        this.setTableItems();
      },
      deep: true,
      immediate: false,
    },
    loading: {
      handler: function (newVal) {
        this.$emit("handleLoading", newVal);
      },
      deep: true,
    },
  },
};
</script>
